import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  personaApiURL,
  personaCompanyApiURL,
  personaPersonalApiURL,
  personasProfileCompanyApiURL,
  workingHoursPersonalApiURL,
} from './apiRoutes';
import { PaginationObject } from '../models/paginationObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { SortObject } from '../models/sortObject';
import { ProfilePerson } from '../models/persona/profile/profilePerson';
import { PersonProfileCompany } from '../models/persona/profile/personProfileCompany';
import { DropdownData } from '../models/dropdownData';
import { WorkingHours } from '../models/persona/profile/workingHours';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(public http: HttpClient) {}
  /* company section */

  getCompanyProfile(id: string): Promise<PersonProfileCompany[]> {
    const sort = sortHelper.constructSort([{prop: 'dateStart', dir: 'asc'}]);
    return this.http.get<PersonProfileCompany[]>(personaApiURL + '/' + id + personaCompanyApiURL + sort).toPromise();
  }

  createCompanyProfile(id: string, data: PersonProfileCompany): Promise<PersonProfileCompany> {
    return this.http.post<PersonProfileCompany>(personaApiURL + '/' + id + personaCompanyApiURL, data).toPromise();
  }

  updateCompanyProfile(id: string, data: PersonProfileCompany): Promise<PersonProfileCompany> {
    return this.http
      .put<PersonProfileCompany>(personaApiURL + '/' + id + personaCompanyApiURL + '/' + data.identifier, data)
      .toPromise();
  }

  splitCompanyProfile(id: string, splitDate:string, subId: string):Observable<PersonProfileCompany>{
    return this.http
    .put<PersonProfileCompany>(personaApiURL + '/' + id + personaCompanyApiURL + '/' + subId + '/split',{},{params:{"splitDate":splitDate}});
  }

  joinCompanyProfile(id: string, companyprofileidentifier:any,subId: string):Observable<PersonProfileCompany>{
    return this.http
    .put<PersonProfileCompany>(personaApiURL + '/' + id + personaCompanyApiURL + '/' + companyprofileidentifier.companyprofileidentifiertokeep + '/join',
      {},
      {
        params:{
          "companyprofileidentifier1":companyprofileidentifier.companyprofileidentifier1,
          "companyprofileidentifier2":companyprofileidentifier.companyprofileidentifier2
        }
      });
  }

  deleteCompanyProfile(personaIdentifier: string, subsectionIdentifier: string) {
    return this.http.put(personaApiURL + '/' + personaIdentifier + personaCompanyApiURL + '/' + subsectionIdentifier + '/status', { status: "DELETED" }).toPromise();
  }

  /* company section end */

  /* personal section */
  getProfilePersonal(id: string): Promise<ProfilePerson> {
    return this.http.get<ProfilePerson>(personaApiURL + '/' + id + personaPersonalApiURL).toPromise();
  }

  updateProfilePerson(personaIdentifier: string, data: ProfilePerson): Promise<ProfilePerson> {
    return this.http
      .post<ProfilePerson>(personaApiURL + '/' + personaIdentifier + personaPersonalApiURL, data)
      .toPromise();
  }
  /* personal section end */

  /* working hours section */
  getAllWorkingHours(id: string): Promise<WorkingHours[]> {
    const sort = sortHelper.constructSort([{prop: 'dateStart', dir: 'asc'}]);
    return this.http.get<WorkingHours[]>(personaApiURL + '/' + id + workingHoursPersonalApiURL + sort).toPromise();
  }

  createProfileWorkingHours(id: string, data: WorkingHours): Promise<WorkingHours> {
    return this.http.post<WorkingHours>(personaApiURL + '/' + id + workingHoursPersonalApiURL, data).toPromise();
  }

  updateProfileWorkingHours(id: string, data: WorkingHours): Promise<WorkingHours> {
    return this.http
      .put<WorkingHours>(personaApiURL + '/' + id + workingHoursPersonalApiURL + '/' + data.identifier, data)
      .toPromise();
  }

  deleteProfileWorkingHours(personaIdentifier: string, subsectionIdentifier: string) {
    return this.http.put(personaApiURL + '/' + personaIdentifier + workingHoursPersonalApiURL + '/' + subsectionIdentifier + '/status', { status: "DELETED" }).toPromise();
  }

  /* working hours section end*/
}
